export default "__VITE_ASSET__C$cRUn2t__"